export type ToastCategory = "standard" | "info" | "success" | "warning" | "error";

export interface NotificationPayload {
    title: string;
    message: string;
    categoryName: ToastCategory;
    duration: number;
}

export interface FrontendEventMap {
    notification: NotificationPayload;
}

type Handler<T> = (payload: T) => void;

class SimpleBus<Events extends object> {
    private listeners = new Map<keyof Events, Set<Handler<unknown>>>();

    on<K extends keyof Events>(event: K, handler: Handler<Events[K]>) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event)!.add(handler as Handler<unknown>);
    }

    off<K extends keyof Events>(event: K, handler: Handler<Events[K]>) {
        this.listeners.get(event)?.delete(handler as Handler<unknown>);
    }

    emit<K extends keyof Events>(event: K, payload: Events[K]) {
        this.listeners.get(event)?.forEach((fn) => (fn as Handler<Events[K]>)(payload));
    }

    removeAllListeners(event?: keyof Events) {
        if (event) {
            this.listeners.delete(event);
        } else {
            this.listeners.clear();
        }
    }

    setMaxListeners(_n: number) {
        // no-op
    }
}

const Bus = new SimpleBus<FrontendEventMap>();

export default Bus;
